'use client';

import { styled } from 'styled-components';
import * as Styled from '@lib/styles';
import type { CustomerLogoProps } from '../components/CustomerLogos';
import CustomerLogos from '../components/CustomerLogos';

const SocialProofContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

const SocialProofTitle = styled(Styled.Eyebrow)`
  margin: 0;
  padding: ${({ theme }) => theme.spacing['2']} 0;
  text-align: center;
`;

type SocialProofProps = CustomerLogoProps & {
  /** Optional eyebrow headline for the logos */
  heading?: string;
};

const SocialProof = ({
  heading = 'Trusted by over 440,000 customers',
  brands,
  className,
}: SocialProofProps) => {
  return (
    <SocialProofContainer className={className}>
      {heading ? <SocialProofTitle as="h3">{heading}</SocialProofTitle> : null}
      <CustomerLogos brands={brands} />
    </SocialProofContainer>
  );
};

export default SocialProof;
